import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-8f7fb048.js';
import { g as getNamespacedTagFor } from './index-739b155e.js';

const MarketPaginationNav = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.marketInternalPaginationNavigation = createEvent(this, "marketInternalPaginationNavigation", 7);
    this.currentPage = undefined;
    this.totalPages = undefined;
    this.hasNextPage = undefined;
    this.hasPreviousPage = undefined;
    this.pageSize = undefined;
  }
  listSelectionEventHandler(e) {
    const { newSelectionValue } = e.detail;
    this.marketInternalPaginationNavigation.emit({
      page: newSelectionValue,
      prevPage: `${this.currentPage}`,
      pageSize: this.pageSize,
    });
  }
  handlePrev() {
    if (this.hasPreviousPage === false || this.currentPage === 1) {
      return;
    }
    const prevPage = this.currentPage - 1;
    this.marketInternalPaginationNavigation.emit({
      page: `${prevPage}`,
      prevPage: `${this.currentPage}`,
      pageSize: this.pageSize,
    });
  }
  handleNext() {
    if (this.hasNextPage === false || (Boolean(this.totalPages) && this.currentPage === this.totalPages)) {
      return;
    }
    const nextPage = this.currentPage + 1;
    this.marketInternalPaginationNavigation.emit({
      page: `${nextPage}`,
      prevPage: `${this.currentPage}`,
      pageSize: this.pageSize,
    });
  }
  render() {
    // Don't render page info when totalPages is missing or set to 0
    const renderPageInfo = Boolean(this.totalPages);
    const hasPreviousPage = this.currentPage > 1 || this.hasPreviousPage;
    const hasNextPage = this.currentPage < this.totalPages || this.hasNextPage;
    // Dropdown navigates by every 10 pages if there are more than 20 pages
    const isLargeDataset = this.totalPages > 20;
    const largeDatasetSteps = 10;
    // pageList for a large dataset = [10, 20, 30, 40, 50...]
    // pageList for a small dataset = [1, 2, 3, 5, 6, 7...]
    const pageList = isLargeDataset
      ? Array.from({ length: Math.floor(this.totalPages / largeDatasetSteps) }).map((_, i) => (i + 1) * largeDatasetSteps)
      : Array.from({ length: this.totalPages }).map((_, i) => i + 1);
    const MarketButtonTagName = getNamespacedTagFor('market-button');
    const MarketButtonDropdownTagName = getNamespacedTagFor('market-button-dropdown');
    const MarketFilterButtonTagName = getNamespacedTagFor('market-filter-button');
    const MarketListTagName = getNamespacedTagFor('market-list');
    const MarketRowTagName = getNamespacedTagFor('market-row');
    return (h(Host, { class: "market-pagination-nav" }, h("nav", null, h(MarketButtonTagName, { size: "small", disabled: !hasPreviousPage, onClick: () => this.handlePrev() }, h("svg", { slot: "icon", width: "15", height: "16", viewBox: "0 0 15 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M0.292894 7.29289C-0.0976308 7.68342 -0.0976307 8.31658 0.292894 8.70711L7.29289 15.7071L8.70711 14.2929L3.41421 9L15 9L15 7L3.41421 7L8.70711 1.70711L7.29289 0.292892L0.292894 7.29289Z", fill: "currentColor" }))), renderPageInfo && (h(MarketButtonDropdownTagName, { "no-caret": true, "popover-placement": "bottom-end", "persist-list": true }, h(MarketFilterButtonTagName, { size: "small", slot: "trigger" }, h("span", null, h("slot", { name: "nav-label" }, "Page")), h("span", { slot: "feedback" }, h("slot", { name: "nav-feedback" }, this.currentPage, " of ", this.totalPages))), h(MarketListTagName, { value: `${this.currentPage}`, slot: "content" }, pageList.map((pageNum) => (h(MarketRowTagName, { key: `pageNav_${pageNum}`, value: `${pageNum}` }, pageNum)))))), h(MarketButtonTagName, { size: "small", disabled: !hasNextPage, onClick: () => this.handleNext() }, h("svg", { slot: "icon", width: "15", height: "16", viewBox: "0 0 15 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L7.70711 15.7071L6.29289 14.2929L11.5858 9L-3.806e-07 9L-2.93177e-07 7L11.5858 7L6.29289 1.70711L7.70711 0.292892L14.7071 7.29289Z", fill: "currentColor" }))))));
  }
  get el() { return getElement(this); }
};

export { MarketPaginationNav as market_pagination_nav };
